import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Form, Input, Switch, Button, Space, message } from 'antd';
import axios from 'axios';

const { Title, Paragraph } = Typography;

const GoogleAdsSettings = () => {
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await axios.get('/api/integrations/google-ads');
        if (data) {
          form.setFieldsValue({
            developer_token: data.developer_token || '',
            client_id: data.client_id || '',
            client_secret: data.client_secret || '',
            refresh_token: data.refresh_token || '',
            login_customer_id: data.login_customer_id || '',
            use_test_account: !!data.use_test_account,
          });
        } else {
          form.setFieldsValue({ use_test_account: false });
        }
      } catch (e) {
        message.error(e.response?.data?.error || 'Failed to load Google Ads settings');
      }
    };
    load();
  }, [form]);

  const onSubmit = async () => {
    try {
      await form.validateFields();
      setSaving(true);
      const values = form.getFieldsValue();
      const headers = {};
      const token = sessionStorage.getItem('token');
      if (token) headers.Authorization = `Bearer ${token}`;
      await axios.put('/api/integrations/google-ads', values, { headers });
      message.success('Google Ads settings saved');
    } catch (e) {
      if (e?.errorFields) return;
      message.error(e.response?.data?.error || e.message || 'Failed to save Google Ads settings');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[
        { title: 'Admin' },
        { title: 'Integrations' },
        { title: 'Google Ads' },
      ]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Google Ads API Settings</Title>
        <Space>
          <Button type="primary" onClick={onSubmit} loading={saving}>Save Settings</Button>
        </Space>
      </div>

      <Card>
        <Paragraph type="secondary" style={{ marginBottom: 12 }}>
          Configure Google Ads API credentials. Replace placeholders with your backend integration endpoints.
        </Paragraph>
        <Form form={form} layout="vertical">
          <Form.Item label="Developer Token" name="developer_token" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="OAuth Client ID" name="client_id" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="OAuth Client Secret" name="client_secret" rules={[{ required: true }]}>
            <Input.Password />
          </Form.Item>
          <Form.Item label="Refresh Token" name="refresh_token" rules={[{ required: true }]}>
            <Input.Password />
          </Form.Item>
          <Form.Item label="Login Customer ID" name="login_customer_id">
            <Input placeholder="e.g., 123-456-7890" />
          </Form.Item>
          <Form.Item label="Use Test Account" name="use_test_account" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default GoogleAdsSettings;
